import React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
} from '@mui/material';

const CloseOutDialog = ({ open, onClose, projectName, loading, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Close Out Project?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This will mark <strong>{projectName}</strong> as completed. All parties will be notified.
        This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Cancel</Button>
      <Button onClick={onConfirm} color="success" variant="contained" disabled={loading}>
        {loading ? 'Closing Out...' : 'Mark as Complete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CloseOutDialog;
